import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Button } from '../ui/button';
import { Menu } from 'lucide-react';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleMenuToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar isOpen={sidebarOpen} onClose={handleSidebarClose} />
      
      {/* Mobile Menu Button */}
      {!sidebarOpen && (
        <Button
          variant="ghost"
          size="icon"
          onClick={handleMenuToggle}
          className="relative top-4 left-4 z-50 lg:hidden bg-white/80 backdrop-blur-sm shadow-md"
        >
          <Menu className="w-5 h-5" />
        </Button>
      )}
      
      <main className="lg:pl-64 transition-all duration-300">
        <div className="p-3 sm:p-4 md:p-6 pt-5 lg:pt-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
